import type { PivotRowDimensionCell, PivotRowResponse } from "../../../../../../../../api/types/svTypes.ts";

/**
 * Fills `lines_<level>` entries for the separate-columns layout: each row carries its ancestor
 * values plus its own, so every row dimension column can render a value. The stack tracks the
 * current group path; a row's own cell lands in the stack at its level, and rows without a valid
 * level (e.g. no lines cell) inherit the current path as-is.
 */
export function enrichTabularFormRows(rows: PivotRowResponse[], levelCount: number): PivotRowResponse[] {
  const parentStack: (PivotRowDimensionCell | undefined)[] = new Array(levelCount).fill(undefined);
  return rows.map((row) => {
    const lines = row["lines"] as PivotRowDimensionCell | undefined;
    const level = lines?.level;
    if (level != null && level >= 0 && level < levelCount) {
      parentStack[level] = lines;
      parentStack.fill(undefined, level + 1);
    }

    const enriched: PivotRowResponse = { ...row };
    parentStack.forEach((cell, cellLevel) => {
      if (cell) {
        enriched[`lines_${cellLevel}`] = cell;
      }
    });

    return enriched;
  });
}
